export default {
  title: 'טעינת מסמכים של הסוכן {1}',
  upload: 'העלאת קובץ',
  deleteFile: 'מחק קובץ',
  editFile: 'עריכת קובץ',
  fileName: 'שם הקובץ',
  notification: {
    success: {
      title: 'הפרטים עודכנו בהצלחה',
      message: 'פרטי הסוכן עודכנו במערכת',
    },
    failure: {
      title: 'הפרטים לא עודכנו',
      message: 'אירעה שגיאה בניסיון העדכון',
    },
    validtion: {
      title: 'הפרטים לא עודכנו',
      message: 'אחד מהפרטים שהוזנו איזו תקין',
    },
    files: {
      title: 'הקבצים לא נשמרו',
      message: 'אחד מהקבצים שהוזנו אינו תקין',
    },
    download: {
      title: '',
      message: 'הקובץ נמצא בתהליך הורדה',
    },
    downloadFaild: {
      title: '',
      message: 'הקובץ נכשל בהורדה',
    },
    successDelete: {
      title: 'הקובץ נמחק בהצלחה',
      message: 'הקובץ נמחק מהמערכת',
    },
  },
  headers: {
    documents: 'מסמכים',
  },
  fileType: 'סוג הקובץ',
  date: 'תאריך',
  download: 'הורדה',
  actions: 'פעולות',
  downloadFaild: {
    title: '',
    message: 'הקובץ נכשל בהורדה',
  },
  uploadSuccess: 'הקבצים נטענו בהצלחה',
  uploadError: 'התרחשה שגיאה בשמירת הקבצים',
};
